import React, {Component,useState} from 'react';
import '../tools/css/BtnEdit.css';

//Componente para boton editar

class BtnEdit extends Component {   
      

      render(){

          const { title } = this.props;

       return (

          <div >

              <button className="btn btn-edit" title={title || "Editar"}>
                  <i className="fas fa-pen"></i>
              </button>

          </div>

      )
  
    }
    
  }  
  
  
  export default BtnEdit;